import { render, staticRenderFns } from "./imgs.vue?vue&type=template&id=06565eb6&"
import script from "./imgs.vue?vue&type=script&lang=js&"
export * from "./imgs.vue?vue&type=script&lang=js&"
import style0 from "./imgs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports